import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const eventsAdapter = createEntityAdapter();

const slice = createSlice({
  name: 'billboardEvents',
  initialState: eventsAdapter.getInitialState(),
  reducers: {
    addEvent: eventsAdapter.upsertOne,
    removeEvent: eventsAdapter.removeOne,
    removeAllEvents: eventsAdapter.removeAll,
    setAllEvents: eventsAdapter.setAll,
    upsertManyEvents: eventsAdapter.upsertMany,
    removeManyEvents: eventsAdapter.removeMany,
  },
});

export const {
  addEvent,
  removeEvent,
  removeAllEvents,
  setAllEvents,
  upsertManyEvents,
  removeManyEvents,
} = slice.actions;

export const simpleSelectors = eventsAdapter.getSelectors();

export default slice.reducer;
